import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const Drive = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
    >
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M16.332 5c.677 0 1.286.4 1.542 1.009l.012.029 2.001 5.037c.07.174.107.358.112.544l.001.043v4.713c0 .888-.73 1.61-1.638 1.625H5.667c-.911 0-1.651-.712-1.667-1.597v-4.741c0-.186.033-.371.097-.547l.016-.04 2.001-5.037C6.36 5.422 6.961 5.013 7.636 5h8.696zm2.001 7.434H5.667c-.369 0-.667.291-.667.65v3.291c0 .352.287.639.646.65h12.687c.362 0 .656-.28.667-.63v-3.31c0-.36-.298-.65-.667-.65zm-1.583 1.504c.506 0 .917.4.917.893 0 .494-.41.894-.917.894-.506 0-.917-.4-.917-.894 0-.493.41-.893.917-.893zm-3.167 0c.507 0 .917.4.917.893 0 .494-.41.894-.917.894-.506 0-.916-.4-.916-.894 0-.493.41-.893.916-.893zm2.749-7.963H7.668c-.267 0-.508.156-.612.394l-.01.021-2.001 5.037-.012.032h13.934l-.006-.016-.006-.016-2.002-5.037c-.096-.243-.332-.406-.598-.415h-.023z"
          transform="translate(-379 -382) translate(290 24) translate(22 200) translate(3 90) translate(0 48) translate(64 20)"
        />
      </g>
    </svg>
  );
};

Drive.defaultProps = {
  width: '24px',
  height: '24px',
  style: {},
};

export default Drive;
